import { useState } from 'react';
import { Activity, Banknote, Globe, Users } from 'lucide-react';
import { EncabezadoDePagina } from '@/shared/ui/EncabezadoDePagina';
import { Pestanas, type Pestana } from '@/shared/ui/Pestanas';
import { ListaDeConsumidores } from './ListaDeConsumidores';
import { PanelDeRecaudacion } from './PanelDeRecaudacion';
import { PanelDeTrafico } from './PanelDeTrafico';

const PESTANAS = [
  {
    clave: 'trafico',
    rotulo: 'Tráfico',
    descripcion: 'Quién llama y cómo va',
    icono: Activity,
  },
  {
    clave: 'recaudacion',
    rotulo: 'Recaudación',
    descripcion: 'Cuánto cobró cada uno',
    icono: Banknote,
  },
  {
    clave: 'consumidores',
    rotulo: 'Instituciones',
    descripcion: 'Quién puede entrar desde fuera',
    icono: Users,
  },
] as const satisfies ReadonlyArray<Pestana<string>>;

type Clave = (typeof PESTANAS)[number]['clave'];

export function PaginaApiPublica() {
  const [pestana, setPestana] = useState<Clave>('trafico');

  return (
    <>
      <EncabezadoDePagina
        icono={Globe}
        color="indigo"
        titulo="API pública"
        subtitulo="Quién llama desde fuera y con qué credenciales"
      />

      <Pestanas
        pestanas={PESTANAS}
        activa={pestana}
        alElegir={setPestana}
        etiqueta="Qué mirar de la API pública"
      />

      {pestana === 'trafico' ? (
        <PanelDeTrafico />
      ) : pestana === 'recaudacion' ? (
        <PanelDeRecaudacion />
      ) : (
        <ListaDeConsumidores />
      )}
    </>
  );
}
